import React from 'react';
import { Skeleton } from '../Skeleton/Skeleton';
import styles from './orderSkeletons.module.scss';

// Скелетон заголовка заказа
export const OrderHeaderSkeleton: React.FC = () => (
  <div className={styles['order-header']}>
    <div className={styles['order-header__actions-row']}>
      <div className={styles['order-header__title-section']}>
        <div className={styles['order-header__title']}>
          <Skeleton variant="text" width="500px" height="40px" />
        </div>
        <div className={styles['order-header__meta']}>
          <Skeleton variant="text" width="500px" height="22px" />
        </div>
      </div>
      <div className={styles['order-header__uuid']}>
        <Skeleton variant="text" width="220px" height="38px" />
      </div>
    </div>
    <div className={styles['order-header__buttons']}>
      <Skeleton variant="rectangular" width="140px" height="38px" />
      <Skeleton variant="rectangular" width="140px" height="38px" />
      <Skeleton variant="rectangular" width="140px" height="38px" />
      <Skeleton variant="rectangular" width="140px" height="38px" />
    </div>
  </div>
);

// Скелетон заголовка "Состав заказа"
export const OrderCompositionHeaderSkeleton: React.FC = () => (
  <div className={styles['order-composition-header']}>
    <Skeleton variant="text" width="170px" height="27px" />
  </div>
);

// Скелетон таблицы товаров
export const OrderTableSkeleton: React.FC<{ count?: number }> = ({
  count = 2
}) => (
  <div className={styles['order-table']}>
    <div className={styles['order-table__wrapper']}>
      {/* Шапка таблицы */}
      <div className={styles['order-table__header']}>
        <Skeleton variant="text" width="100px" height="28px" />
        <div className={styles['order-table__content']}>
          <Skeleton variant="text" width="200px" height="28px" />
          <Skeleton variant="text" width="120px" height="28px" />
          <Skeleton variant="text" width="100px" height="28px" />
          <Skeleton variant="text" width="120px" height="28px" />
          <Skeleton variant="text" width="100px" height="28px" />
        </div>
      </div>

      {/* Строки товаров */}
      {Array.from({ length: count }, (_, index) => (
        <div key={index} className={styles['order-table__row']}>
          <Skeleton
            variant="rectangular"
            width="100px"
            height="100px"
            className={styles['order-table__image']}
          />
          <div className={styles['order-table__content']}>
            <Skeleton variant="text" width="200px" height="34px" />
            <Skeleton variant="text" width="120px" height="34px" />
            <Skeleton variant="text" width="100px" height="34px" />
            <Skeleton variant="text" width="120px" height="34px" />
            <Skeleton variant="text" width="100px" height="34px" />
          </div>
        </div>
      ))}
    </div>
  </div>
);

// Скелетон итоговых сумм
export const OrderTotalsSkeleton: React.FC = () => (
  <div className={styles['order-totals']}>
    <div className={styles['order-totals__row']}>
      <div className={styles['order-totals__label']}>
        <Skeleton variant="text" width="150px" height="20px" />
      </div>
      <div className={styles['order-totals__value']}>
        <Skeleton variant="text" width="80px" height="20px" />
      </div>
    </div>
    <div className={styles['order-totals__row']}>
      <div className={styles['order-totals__label']}>
        <Skeleton variant="text" width="150px" height="20px" />
      </div>
      <div className={styles['order-totals__value']}>
        <Skeleton variant="text" width="80px" height="20px" />
      </div>
    </div>
    <div className={styles['order-totals__row']}>
      <div className={styles['order-totals__label']}>
        <Skeleton variant="text" width="150px" height="24px" />
      </div>
      <div className={styles['order-totals__value']}>
        <Skeleton variant="text" width="80px" height="24px" />
      </div>
    </div>
  </div>
);

// Скелетон аккордеонов
export const OrderAccordionsSkeleton: React.FC<{ count?: number }> = ({
  count = 7
}) => (
  <div className={styles['order-accordions']}>
    {Array.from({ length: count }, (_, index) => (
      <Skeleton
        key={index}
        variant="rectangular"
        width="100%"
        height="70px"
        className={styles['order-accordions__item']}
      />
    ))}
  </div>
);

// Скелетон формы доставки
export const DeliveryFormSkeleton: React.FC = () => (
  <div className={styles['delivery-form']}>
    <div className={styles['delivery-form__header']}>
      <Skeleton variant="text" width="260px" height="32px" />
      <Skeleton variant="text" width="220px" height="32px" />
    </div>
    <div className={styles['delivery-form__divider']} />
    <div className={styles['delivery-form__offers-header']}>
      <Skeleton variant="text" width="220px" height="38px" />
      <Skeleton variant="rectangular" width="260px" height="38px" />
    </div>
    <div className={styles['delivery-form__offers-list']}>
      {[...Array(2)].map((_, i) => (
        <div key={i} className={styles['delivery-form__offer-row']}>
          <Skeleton variant="rectangular" width="60px" height="60px" />
          <Skeleton variant="text" width="200px" height="22px" />
          <div className={styles['delivery-form__offer-controls']}>
            <Skeleton variant="rectangular" width="120px" height="38px" />
            <Skeleton variant="rectangular" width="120px" height="38px" />
          </div>
        </div>
      ))}
    </div>
    <div className={styles['delivery-form__divider']} />
    <div className={styles['delivery-form__application']}>
      <div className={styles['delivery-form__application-row']}>
        <Skeleton variant="text" width="200px" height="32px" />
        <Skeleton variant="text" width="180px" height="32px" />
      </div>
      <div className={styles['delivery-form__application-full']}>
        <Skeleton variant="rectangular" width="100%" height="38px" />
      </div>
      <div className={styles['delivery-form__application-row']}>
        <Skeleton variant="text" width="220px" height="32px" />
        <Skeleton variant="text" width="160px" height="32px" />
      </div>
      <div className={styles['delivery-form__comment']}>
        <Skeleton variant="rectangular" width="100%" height="80px" />
      </div>
      <div className={styles['delivery-form__actions']}>
        <Skeleton variant="rectangular" width="160px" height="44px" />
        <Skeleton variant="rectangular" width="120px" height="44px" />
      </div>
    </div>
  </div>
);

export const OrderPageSkeleton: React.FC = () => (
  <div className={styles['order-page']}>
    <OrderHeaderSkeleton />
    <OrderCompositionHeaderSkeleton />
    <OrderTableSkeleton count={2} />
    <OrderTotalsSkeleton />
    <OrderAccordionsSkeleton count={7} />
    <DeliveryFormSkeleton />
  </div>
);
